import React from "react";
import { find, map } from "lodash";
import { getMetricLabel } from "@linkfluence/i18n";
import { Metric } from "@linkfluence/models/metric";
import Dropdown from "@radarly/components/panels/card-edition/sidebar/dropdown";
import { useCurrentProjectFocusesId } from "@radarly/core/project/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { useCurrentWorkspaceId } from "@radarly/core/workspace/use-cases";
import { tr } from "@radarly/i18n";
import { Card } from "@radarly/models/cards";
import { setCardPrimaryMetric } from "@radarly/models/cards/editor";
import {
  getAvailableMetricsFromCard,
  getPrimaryMetricFromCard,
} from "@radarly/models/cards/metric";

export interface SharedPanelsCardEditionSidebarFieldProps {
  card: Card;
  setCard: (card: Card) => void;
}

export default function SharedPanelsCardEditionSidebarField({
  card,
  setCard,
}: SharedPanelsCardEditionSidebarFieldProps) {
  const workspaceId = useCurrentWorkspaceId();
  const projectFocuses = useCurrentProjectFocusesId();
  const locale = useCurrentUserLocale();
  const cardMetric = getPrimaryMetricFromCard(card);
  const currentAvailableMetrics = getAvailableMetricsFromCard(card);
  const options = map(currentAvailableMetrics, (m) => ({
    value: m,
    label: getMetricLabel(locale, m),
  }));
  const option = find(options, { value: cardMetric });
  return (
    <Dropdown
      label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::METRIC")}
      value={option}
      options={options}
      onChange={({ value }) =>
        setCard(
          setCardPrimaryMetric(
            workspaceId,
            projectFocuses,
            card,
            value as Metric
          )
        )
      }
    />
  );
}
